import { render } from "./VideoComponent.vue?vue&type=template&id=d2f5f5ec&scoped=true"
import script from "./VideoComponent.vue?vue&type=script&lang=js"
export * from "./VideoComponent.vue?vue&type=script&lang=js"

import "./VideoComponent.vue?vue&type=style&index=0&id=d2f5f5ec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2f5f5ec"]])

export default __exports__